<ng-container>
  @if (!custom) {
    @if (outlined) {
      <mat-icon fontSet="material-icons-outlined" [ngStyle]="{ 'font-size': size, color: color }" class="!w-fit !h-fit">
        {{ icon }}
      </mat-icon>
    } @else {
      <mat-icon [ngStyle]="{ 'font-size': size, color: color }" class="!w-fit !h-fit">
        {{ icon }}
      </mat-icon>
    }
  } @else {
    <i [class]="icon" [ngStyle]="{ 'font-size': size, color: color }" class="!w-fit !h-fit"></i>
  }
</ng-container>
